import instance from '@apis/instance';
import {
    ExternalGiftBoxRequest, GetReceivedGiftBoxParams, GetSentGiftBoxParams,
    GiftUsageRow, ReceivedGiftBoxRow, SentGiftBoxRow,
    GetGiftBoxParams,
    GiftBoxResponse, GiftBoxRow, GiftBoxType,
} from '@models/gift';
import { SliceResponse } from '@models/page';

class GiftBoxApi {
    static getGiftBoxes(giftBoxType: GiftBoxType, sorter: string): Promise<SliceResponse<GiftBoxRow>> {
        return instance.get('/v0/gift-box', { params: { giftBoxType, sorter } });
    }

    static getGiftBox(giftBoxId: string, params: GetGiftBoxParams): Promise<GiftBoxResponse> {
        return instance.get(`/v0/gift-box/${giftBoxId}`, { params });
    }

    static getReceivedGiftBoxes(params: GetReceivedGiftBoxParams): Promise<SliceResponse<ReceivedGiftBoxRow>> {
        return instance.get('/v0/gift-box/received', { params });
    }

    static getSentGiftBoxes(params: GetSentGiftBoxParams): Promise<SliceResponse<SentGiftBoxRow>> {
        return instance.get('/v0/gift-box/sent', { params });
    }

    static getUsage(giftCouponId: string): Promise<GiftUsageRow[]> {
        return instance.get(`/v0/gift-box/coupons/${giftCouponId}/usages`);
    }

    static registerExternalGift(request: ExternalGiftBoxRequest): Promise<never> {
        return instance.post('/v0/gift-box', request);
    }

    static deleteGiftCoupon(giftCouponId: string): Promise<never> {
        return instance.delete(`/v0/gift-box/coupons/${giftCouponId}`);
    }
}

export default GiftBoxApi;
